import script from "./NewTask.vue?vue&type=script&setup=true&lang=js"
export * from "./NewTask.vue?vue&type=script&setup=true&lang=js"

import "./NewTask.vue?vue&type=style&index=0&id=55c30f20&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55c30f20"]])

export default __exports__